import React, { Component } from 'react';
import { useState, useEffect } from "react";
import logo from './logo.svg';
import './App.css';
import './spapp.css';
import './common.css';

import Select from 'react-select';
import Header from './Header';

import Home from './Home';

import * as ReactDOM from 'react-dom';
import Searchcriteria from './Searchcriteria';
import {clearmain,clearprofile} from './clearmem';
import btnchatgpt from './imgs/btnchatgpt.png';
import axios from 'axios';
import Configdata from './Defaultdata';
import Process from './imgs/process.gif';
import Signup from './Signup';
import { hidediv } from './Dynamictable';

//import  {Cthmchat} from './Chat';
function App() {
	useEffect(() => {
		const link = document.querySelector('link[rel="icon"]');

		if (link) {
			link.setAttribute('href', 'favicon-devp.ico');
		
		}
	     // showchat();
	}, []);

function showchat(){
	var process = document.getElementById('processiconchat') as HTMLElement;
	var txt = document.getElementById('txtasked') as HTMLInputElement; 
                process.style.display = 'block';

           const url = '/getchatgptmsg';
	  const utxt = txt.value;
          const jsondata = {txt:utxt};
       try {
	           const response = axios.post(Configdata.srvurl + url,jsondata, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                process.style.display = 'none';
                const txtchatgpt = document.getElementById('chatgptmsgshow') as HTMLElement;
                txtchatgpt.style.display = 'block';
		txtchatgpt.innerHTML = usercd;
                 //    alert(usercd);

	        });		
              
	     }
	   }
         
        catch (ex:any) {
              process.style.display = 'none';

        }

}
function usersineupform(){
	   try {
		
		const signups = <Signup />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		
		if(maindiv){
		maindiv.style.display = 'block';
  		ReactDOM.render(signups,maindiv);
                hidechatdv();
                 }
                if(Pdivr)
		Pdivr.style.display = 'none';
	   }
	    catch(e){
		
	     }	
	}
function hidechatdv(){
	    hidediv('txtchatgtp');
     	    hidediv('processiconchat');
           hidediv('chatgptmsgshow');

	}

//localStorage.setItem("id","0");
  return (
	
  
       <div style={{ width: '99.8%', height: '99%' }}>
		  
		 <div className="headermaindiv">
			  <Header />
		</div>
		<div id="container" className="per100">
			  <Home />
		</div>
		<div id="profilediv" className="sidebar-profile">
		
		</div>
		<div id="customemsgdiv" className="custom-msg">
			
		</div>
		<div id="chatgptmsgshow" className="chatgpt-msg">
			
		</div>
		<div id="processiconchat" className="processicon-chat">
			<img style={{width:'100%',marginTop:'0px',height:'40px',color:'#000000'}} src={Process} />
		</div>

		<div id="txtchatgtp" className="custom-chatgpt">
			<div className="postingrowdiv" style={{backgroundColor:'transparent',display:'none'}}>
                             
			<textarea placeholder="Ask anything" style={{width:'95%',zIndex:'2200',float:'left',height:'8vh',backgroundColor:'transparent'}} id="txtasked" className="postingtxtbox" />
                                   <a  href="#"  onClick={showchat} title="Search"><img src={btnchatgpt}  style={{width:'5vh',height:'5vh',zIndex:'2200',position:'absolute',float:'left',paddingRight:'0px',top:'5vh'}} /></a>

                                 
			</div>
                         
<div id="freepost" className="free-post">
			 <a  href="#"  onClick={usersineupform} title="Free post">Free post</a>

		</div>

		</div>
		

		
          
       </div>

      );
}

export default App;
